const monthNames = [
	`января`,
	`февраля`,
	`марта`,
	`апреля`,
	`мая`,
	`июня`,
	`июля`,
	`августа`,
	`сентября`,
	`октября`,
	`ноября`,
	`декабря`
]

export const timeFormatter = (value: string) => {
	const formattedTime = new Date(value)
	const day = formattedTime.getUTCDate()

	return `${day} ${monthNames[formattedTime.getMonth()]}`
}
